"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const addAssignEvent_1 = tslib_1.__importDefault(require("./addAssignEvent"));
const updateEnrolments_1 = tslib_1.__importDefault(require("./updateEnrolments"));
function updateRootEnrolmentAndGenerateEvent(states, enrolments, command, content, user, stateInteractions) {
    const updatedStates = states;
    const updatedStateInteractions = stateInteractions;
    let updatedEnrolments = enrolments;
    const newEvents = [];
    updatedEnrolments = updateEnrolments_1.default(enrolments, command, content, user);
    const diffEnrolments = updatedEnrolments.filter((enrolment, index) => {
        if (enrolment !== enrolments[index]) {
            return enrolment;
        }
    });
    if (diffEnrolments.length > 0) {
        addAssignEvent_1.default(command, updatedEnrolments, user, content, newEvents);
    }
    return {
        events: newEvents,
        states: updatedStates,
        stateInteractions: updatedStateInteractions,
        enrolments: updatedEnrolments
    };
}
exports.updateRootEnrolmentAndGenerateEvent = updateRootEnrolmentAndGenerateEvent;
//# sourceMappingURL=updateRootEnrolmentAndGenerateEvent.js.map